import {
  FFS_ENABLED_ASSET_TYPES,
  FFS_ENABLED_ORGS,
} from 'features/libra/stepComponents/ffs/constants/ffsConstants'
import { GeckoAssetModelType } from 'types'

export function canCreateFfsTicket({
  orgId,
  assetType,
}: {
  orgId: string | undefined
  assetType: GeckoAssetModelType | undefined
}): boolean {
  return (
    orgId !== undefined &&
    FFS_ENABLED_ORGS.includes(orgId) &&
    assetType !== undefined &&
    FFS_ENABLED_ASSET_TYPES.includes(assetType)
  )
}
